import React, { useEffect, useState } from "react";
import Button from "../../../components/common/button/Button";
import Icons from "../../../assets/icons";
import QRCode from "react-qr-code";
import styled from "./LiveSaleSessionList.module.css";
import CreateLiveSale from "../create_live_sale/CreateLiveSale";
import InputSelect from "../../../components/common/input/InputSelect";
import callApi from "../../../services/api/apiClient";
import { useSelector } from "react-redux";
import moment from "moment";
import ModalProvider from "../../../components/modal/ModalProvider";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../../components/toast/Toast";

const LiveSaleSessionList = () => {
  const roomList = useSelector((state) => state?.liveSale?.roomList)?.data;

  const navigate = useNavigate();
  const { showToast } = useToast();

  const [create, setCreate] = useState(false);
  const [selectRoom, setSelectRoom] = useState(null);
  const [list, setList] = useState([]);
  const [detail, setDetail] = useState(null);
  const [click_action, setClick_action] = useState(false);
  const [session_id, setSession_id] = useState(null);
  const [isDelete, setIsDelete] = useState(false);

  useEffect(() => {
    listSaleRoom();
    if (selectRoom?.value) {
      sessionList(selectRoom);
    }
  }, [selectRoom]);

  const listSaleRoom = () => {
    callApi("liveSale/roomList").loadingGroup("LiveSale").executeDispatch();
  };

  const sessionList = (id) => {
    callApi("liveSale/liveSaleSessionList")
      .withParam({ room_id: id })
      .loadingGroup("LiveSale")
      .execute()
      .then((res) => {
        setList(res);
      });
  };

  const callSessionDetail = (id) => {
    callApi("liveSale/liveSaleSessionDetail")
      .withKeyParameter({ sessionId: id })
      .loadingGroup("LiveSale")
      .execute()
      .then((res) => {
        setDetail(res);
      });
  };

  const onStartSession = () => {
    callApi("liveSale/startLiveSaleSession")
      .withKeyParameter({ sessionId: session_id })
      .loadingGroup("LiveSale")
      .execute()
      .then((res) => {
        if (res?.status === "success") {
          sessionList(selectRoom);
          // callSessionDetail(session_id)
          showToast("Start Session is successful!", "success");
        } else {
          console.log("Error", res?.error);
          showToast(res?.message, "error");
        }
      });
  };

  const onStopSession = () => {
    callApi("liveSale/stopLiveSaleSession")
      .withKeyParameter({ sessionId: session_id })
      .loadingGroup("LiveSale")
      .execute()
      .then((res) => {
        if (res?.status === "success") {
          sessionList(selectRoom);
          callSessionDetail(session_id);
          showToast("Stop Session is successful!", "success");
        } else {
          showToast(res?.message ? res?.message : res?.error, "error");
          console.log("Error", res?.error);
        }
      });
  };

  const onDeleteLiveSale = () => {
    callApi("liveSale/deleteLiveSale")
      .withKeyParameter({ id: session_id })
      .execute()
      .then((res) => {
        if (res?.status === "success") {
          setIsDelete(false);
          sessionList(selectRoom);
          showToast("Delete Session is successful!", "success");
        } else {
          showToast(res?.message ? res?.message : res?.error, "error");
          console.log("Error", res?.error);
        }
      });
  };

  const statusColor = (status) => {
    switch (status) {
      case "ready":
        return { color: "#FBEDCA", name: "Upcoming", textColor: "#EFB92D" };
      case "open":
        return { color: "#FFBFBF", name: "In Progress", textColor: "#FF0000" };
      case "close":
        return { color: "#D0DAE3", name: "Finished", textColor: "#333333" };
      default:
        return null;
    }
  };

  return (
    <div className="">
      <div className={styled.gridContainer}>
        <div
          class={`relative overflow-x-auto col-span-6 p-6 h-full md:h-full ${
            selectRoom && click_action ? "sm:col-span-4" : "sm:col-span-6"
          } `}
        >
          <div className="flex flex-row justify-between items-center mb-4 mx-6">
            <h1 className={styled.mainTitle}>Live Sale Sessions</h1>
            <div className="flex flex-row items-center">
              <Button
                type={"submit"}
                disabled={selectRoom ? false : true}
                onClick={() => setCreate(true)}
                className={` bg-blue-1 mt-2 mr-3 ${
                  selectRoom ? "text-white-0" : "text-gray-0"
                } text-sm h-[48px]  p-[8px] rounded-[8px] flex items-center `}
              >
                Create New
              </Button>
              <InputSelect
                name={"saleRoom"}
                data={roomList}
                className={"w-[200px]"}
                value={selectRoom?.name}
                onChange={(event) => {
                  // console.log("select room", item)
                  setSelectRoom(event.target.value);
                  sessionList(event?.target.value);
                }}
                placeholder="Select"
              />
            </div>
          </div>

          <table className={styled.liveSaleTable}>
            <thead class="text-xs text-white-700">
              <tr className="border-b">
                <th scope="col" className={styled.tableTitle}>
                  Live Sale No.
                </th>
                <th scope="col" className={styled.tableTitle}>
                  Date
                </th>
                <th scope="col" className={styled.tableTitle}>
                  Time
                </th>
                <th scope="col" className={styled.tableTitle}>
                  Status
                </th>
                <th scope="col" className={styled.tableTitle}></th>
              </tr>
            </thead>
            <tbody>
              {list?.data?.length > 0 ? (
                list?.data?.map((item, index) => (
                  <tr
                    key={index}
                    className={`${styled.tableBody} ${
                      item?.id === session_id ? "bg-blue-2" : "null"
                    }`}
                  >
                    <td className={styled.liveSaleNo}>{item?.barcode}</td>
                    <td
                      className={styled.bodyItem}
                      onClick={() => {
                        callSessionDetail(item?.id);
                        setSession_id(item?.id);
                        setClick_action(true);
                      }}
                    >
                      {moment(item?.Date).format("DD MMM YYYY")}
                    </td>
                    <td className={styled.bodyItem}>
                      {moment(item?.from).format("hh:mm")} -{" "}
                      {moment(item?.to).format("hh:mm")}
                    </td>
                    <td className={styled.bodyItem}>
                      <div
                        className={styled.statusBtn}
                        style={{
                          backgroundColor: statusColor(item?.status)?.color,
                        }}
                      >
                        <p
                          className={styled.statusText}
                          style={{
                            color: statusColor(item?.status)?.textColor,
                          }}
                        >
                          {statusColor(item?.status)?.name}
                        </p>
                      </div>
                    </td>
                    <td
                      className={styled.bodyItem}
                      onClick={() => {
                        setIsDelete(true);
                        setSession_id(item?.id);
                      }}
                    >
                      <img
                        src={Icons.deleteIcon}
                        alt="deleteIcon"
                        className="w-[16px] h-[20px]"
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <td>
                  <p className="text-center text-base self-center mt-6">
                    Please choose room id.
                  </p>
                </td>
              )}
            </tbody>
          </table>
        </div>

        {selectRoom && click_action && (
          <div className={styled.secondColumn}>
            <h2 className="text-lg font-bold font-interSemiBold">
              Upcoming Live Sale Session
            </h2>
            <div className={styled.saleCard}>
              <table className="w-full">
                <tbody>
                  <tr>
                    <td className="px-4 text-sm font-interSemiBold">
                      Room Name{" "}
                    </td>
                    <td>:</td>
                    <td className="px-2 text-sm font-interSemiBold">
                      {detail?.barcode}
                    </td>
                  </tr>
                  <tr>
                    <td className={styled.cardText}>Date</td>
                    <td>:</td>
                    <td className={styled.cardText}>
                      {moment(detail?.Date).format("DD MMM YYYY")}
                    </td>
                  </tr>
                  <tr>
                    <td className={styled.cardText}>Time</td>
                    <td>:</td>
                    <td className={styled.cardText}>
                      {moment(detail?.from).format("hh:mm")} -{" "}
                      {moment(detail?.to).format("hh:mm")}
                    </td>
                  </tr>
                  <tr>
                    <td className={styled.cardText}>Status</td>
                    <td>:</td>
                    <td className="px-2 text-sm font-interRegular">
                      <div
                        className={styled.statusBtn}
                        style={{
                          backgroundColor: statusColor(detail?.status)?.color,
                        }}
                      >
                        <p
                          className={styled.statusText}
                          style={{
                            color: statusColor(detail?.status)?.textColor,
                          }}
                        >
                          {statusColor(detail?.status)?.name}
                        </p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              {detail?.status === "close" && <hr className="w-full mt-3" />}

              {detail?.helper?.length > 0 && (
                <div className=" p-3">
                  <p className="text-base text-blue-1 font-interSemiBold">
                    Helper
                  </p>
                  {detail?.helper?.map((item, index) => (
                    <div className="flex items-center mt-3" key={index}>
                      <img
                        src={Icons.user}
                        alt="user"
                        className="w-[24px] h-[24px]"
                      />
                      <p className="text-sm ml-3">{item?.name} (Helper Name)</p>
                    </div>
                  ))}
                </div>
              )}

              {detail?.status === "open" && (
                <>
                  <div className="w-full justify-center flex mt-6">
                    <div className="rounded-[8px] w-[240px] h-[240px] p-5 border">
                      <QRCode
                        size={256}
                        style={{
                          height: "auto",
                          maxWidth: "100%",
                          width: "100%",
                        }}
                        value={detail?.barcode}
                        viewBox={`0 0 256 256`}
                      />
                    </div>
                  </div>

                  <p className="text-base text-blue-1 font-interSemiBold mt-3 text-center">
                    Scan QR to join session
                  </p>
                </>
              )}

              {detail?.status === "ready" ? (
                <Button
                  type={"submit"}
                  className={styled.startBtn}
                  onClick={() => {
                    onStartSession();
                  }}
                >
                  Start Session
                </Button>
              ) : detail?.status === "open" ? (
                <Button
                  type={"submit"}
                  className={styled.startBtn}
                  onClick={() => {
                    onStopSession();
                  }}
                >
                  Stop Session
                </Button>
              ) : null}
            </div>

            <Button
              type={"submit"}
              className={styled.saleOrderBtn}
              onClick={() => {
                navigate("/sale_order");
              }}
            >
              <span>
                <img
                  src={Icons.saleIcon}
                  alt="saleIcon"
                  className="w-[14px] h-[14px] mr-3"
                />
              </span>
              Sale Order List
            </Button>
          </div>
        )}
      </div>

      {create && (
        <CreateLiveSale
          isOpen={create}
          onClose={() => setCreate(false)}
          selectRoom={selectRoom}
          sessionList={(id) => sessionList(id)}
        />
      )}

      <ModalProvider
        isOpen={isDelete}
        onClose={() => setIsDelete(false)}
        title={"Delete Live Sale Session List"}
        cancelBtn={() => setIsDelete(false)}
        sendBtn={() => onDeleteLiveSale()}
        description={"Are you sure you want to  delete this product?"}
      />
    </div>
  );
};

export default LiveSaleSessionList;
